export const COMPANY_TERMS_TYPE_DICTIONARY = {
  termos_e_condicoes_de_uso: 'Termos e condições de uso',
  codigo_de_conduta: 'Código de Conduta',
  contrato_de_viagens_extras: 'Contrato de Viagens Extras',
};
